import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { SGSSelect, SGSSelectProps } from 'components';
import { useTranslation } from 'react-i18next';

type Props = SGSSelectProps;

const SGSFormSelect: React.FC<Props> = ({ name, label, options, multiple, variant, ...props }) => {
    const { control } = useFormContext();
    const { t } = useTranslation();
    return (
        <Controller
            {...props}
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <SGSSelect
                    {...field}
                    multiple={multiple}
                    label={t(label as string)}
                    error={!!error}
                    variant={variant}
                    helperText={error?.message || ''}
                    value={field.value || (multiple ? [] : '')}
                    options={[{ value: '', label: <>&nbsp;</> }, ...options]}
                />
            )}
        />
    );
};

export default SGSFormSelect;
